export default __webpack_public_path__ + "static/media/mobile-de.de9633d0.png";